export default {
  documentsList: [],
  reportsList: [],
  documentUploadingProgress: 0
}



// WEBPACK FOOTER //
// ./src/store/documents/defaults.js